import { graphql, commitMutation } from 'react-relay';

const mutation = graphql`
    mutation RenderCatalogEmailMutation($input: RenderCatalogEmailInput!) {
        renderCatalogEmail(input: $input) {
            clientMutationId
        }
    }
`;

const commit = (environment, args) => {
    const {
        catalogIds,
        message,
        recipientEmails,
        senderEmail,
        senderName,
        onCompleted,
        onError,
    } = args;

    const input = { ...catalogIds, message, recipientEmails, senderEmail, senderName };

    commitMutation(environment, {
        mutation,
        variables: {
            input,
        },
        onCompleted,
        onError,
    });
};

export default { commit };
